export function getLineOfficialUrl() {
  return process.env.REACT_APP_LINE_OFFICIAL_URL?.trim() || '';
}
